import { __makeTemplateObject } from "tslib";
import styled, { css } from "styled-components";
import { ButtonColors } from "./ButtonColors";
var getVariantStyles = function (variant, buttonColor) {
    if (variant === void 0) { variant = "outlined"; }
    if (buttonColor === void 0) { buttonColor = "primary"; }
    var palette = ButtonColors[buttonColor];
    switch (variant) {
        case "outlined":
            return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        background-color: transparent;\n        border: 1.5px solid ", ";\n        &:hover {\n          background-color: rgba(25, 118, 210, 0.04);\n        }\n      "], ["\n        color: ", ";\n        background-color: transparent;\n        border: 1.5px solid ", ";\n        &:hover {\n          background-color: rgba(25, 118, 210, 0.04);\n        }\n      "])), palette.main, palette.border);
        case "text":
            return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        color: ", ";\n        background-color: transparent;\n        border: none;\n        &:hover {\n          background-color: rgba(25, 118, 210, 0.08);\n        }\n      "], ["\n        color: ", ";\n        background-color: transparent;\n        border: none;\n        &:hover {\n          background-color: rgba(25, 118, 210, 0.08);\n        }\n      "])), palette.main);
        case "contained":
        default:
            return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n        border: none;\n        &:hover {\n          background-color: ", ";\n        }\n      "], ["\n        color: ", ";\n        background-color: ", ";\n        border: none;\n        &:hover {\n          background-color: ", ";\n        }\n      "])), palette.contrastText, palette.main, palette.hover);
    }
};
var getSizeStyles = function (size) {
    if (size === void 0) { size = "medium"; }
    switch (size) {
        case "small":
            return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        font-size: 0.75rem;\n        padding: 6px 12px;\n      "], ["\n        font-size: 0.75rem;\n        padding: 6px 12px;\n      "])));
        case "large":
            return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        font-size: 1rem;\n        padding: 10px 24px;\n      "], ["\n        font-size: 1rem;\n        padding: 10px 24px;\n      "])));
        case "medium":
        default:
            return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        font-size: 0.875rem;\n        padding: 8px 16px;\n      "], ["\n        font-size: 0.875rem;\n        padding: 8px 16px;\n      "])));
    }
};
export var CustomButton = styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  ", "\n\n  font-weight: 500;\n  border-radius: ", ";\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", ";\n  text-transform: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  transition: all 0.3s ease;\n"], ["\n  ", "\n  ", "\n\n  font-weight: 500;\n  border-radius: ", ";\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", ";\n  text-transform: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  transition: all 0.3s ease;\n"])), function (_a) {
    var variant = _a.variant, buttonColor = _a.buttonColor;
    return getVariantStyles(variant, buttonColor);
}, function (_a) {
    var size = _a.size;
    return getSizeStyles(size);
}, function (_a) {
    var _b = _a.borderRadius, borderRadius = _b === void 0 ? "16px" : _b;
    return borderRadius;
}, function (_a) {
    var _b = _a.$justifyContent, $justifyContent = _b === void 0 ? "center" : _b;
    return $justifyContent;
}, function (_a) {
    var _b = _a.alignItems, alignItems = _b === void 0 ? "center" : _b;
    return alignItems;
}, function (_a) {
    var _b = _a.gap, gap = _b === void 0 ? "6px" : _b;
    return gap;
}, function (_a) {
    var _b = _a.textTransform, textTransform = _b === void 0 ? "capitalize" : _b;
    return textTransform;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "not-allowed" : "pointer");
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.6 : 1);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
